export const ROLEABLE_ADMIN_PERMISSION = "admin";
